import { render, staticRenderFns } from "./ClientIntercomDialog.vue?vue&type=template&id=52b43a3a&"
import script from "./ClientIntercomDialog.vue?vue&type=script&lang=js&"
export * from "./ClientIntercomDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports